export default __webpack_public_path__ + "static/media/Mark-6-HUD-09.61dcdd4a.jpg";